export default __webpack_public_path__ + "static/media/newInviteIcon.f27c9fd6.svg";